<template>
  <v-app>
    <v-navigation-drawer
      width="350"
      right
      v-model="showDrawer"
      dark
      color="#00558C"
      temporary
      clipped
      app
      style="z-index: 500"
    >
      <v-list-item v-for="link in links" :key="link.name" link>
        <v-list-item-content @click.stop="$router.push(link.route)">
          <v-list-item-title class="navDrawer">
            <v-icon v-if="link.icon">{{ link.icon }}</v-icon>
            &nbsp;
            {{ link.name }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item link v-if="showLogOut == true">
        <v-list-item-content @click.stop="logOut">
          <v-list-item-title class="navDrawer">
            <v-icon>mdi-close-circle</v-icon>&nbsp; Log Out
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-navigation-drawer>

    <v-container fluid style="margin: 0; padding: 0">
      <v-app-bar
        app
        color="#00558C"
        dark
        height="75"
        no-gutters
        style="z-index: 400"
      >
        <div style="width: 225px">
          <v-img
            height="41"
            width="220"
            :src="require('@/assets/Globe_Life-220.png')"
            @click="homeClick"
            class="logo"
            contain
          ></v-img>
        </div>

        <h1 v-if="$vuetify.breakpoint.mdAndUp" style="margin-left: 50px">
          Agency Maintenance Tool
        </h1>

        <v-spacer></v-spacer>
        <span
          v-if="
            userName && $vuetify.breakpoint.mdAndUp && $route.path != '/login'
          "
          style="margin-right: 50px"
          >Welcome {{ userName }}!</span
        >

        <v-app-bar-nav-icon
          @click="showDrawer = !showDrawer"
        ></v-app-bar-nav-icon>
      </v-app-bar>

      <v-main style="margin: 0; padding: 0">
        <v-row class="padBottom" no-gutters>
          <v-flex xs12>
            <router-view
              :routeName="$route.name"
              class="routerView"
            ></router-view>
          </v-flex>
        </v-row>
      </v-main>

      <v-footer height="auto" color="#00558C" fixed style="z-index: 400">
        <v-flex>
          <v-layout justify-center>
            <span class="footerText">&copy;2020 Globe Life</span>
          </v-layout>
        </v-flex>
      </v-footer>
    </v-container>

    <modal
      name="unlockedMsgModal"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
    >
      <v-card style="height: 200px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>System Message</v-toolbar-title>
        </v-toolbar>
        <v-card-subtitle
          v-if="
            $store.state.currentUser &&
              $store.state.currentUser.agentNum ==
                $store.state.unlockMsg.AOAgentNum
          "
        >
          Your hierarchy has been unlocked. If you need to edit the hierarchy,
          you may now do so.
        </v-card-subtitle>
        <v-card-subtitle v-else>
          {{ unlockAOName }}'s hierarchy has been unlocked. If you need to edit
          this hierarchy, you may now do so.
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer /> <v-spacer />
          <v-btn color="#00558C" dark @click="onCloseUnlockedMsgModal"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <v-dialog v-model="logOutDialog" persistent width="350" id="logOutDialog">
      <v-card>
        <v-card-title class="headline logOutDialogHeadline">
          <v-icon color="#00558C" large>mdi-close-circle</v-icon>&nbsp;Log Out
        </v-card-title>

        <v-layout align-center justify-center>
          <hr width="90%" />
        </v-layout>

        <v-card-text>Are you sure you want to log out?</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#319B42"
            dark
            class="menuBtn"
            @click="
              logOutDialog = false;
              logOutAWS();
            "
            >Yes</v-btn
          >
          <v-btn
            color="#319B42"
            dark
            class="menuBtn"
            @click="logOutDialog = false"
            >No</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="activeCheckDialog"
      persistent
      width="350"
      ref="activeCheckDialog"
    >
      <v-card>
        <v-card-title class="headline logOutDialogHeadline">
          <v-icon color="#00558C" large>mdi-account</v-icon>&nbsp;Are you still
          there?
        </v-card-title>

        <v-layout align-center justify-center>
          <hr width="90%" />
        </v-layout>

        <v-card-text>
          Your session is about to end. If you are still working, please click
          OK to continue.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#319B42"
            dark
            class="menuBtn"
            @click="
              activeCheckDialog = false;
              setLastActiveTimeStamp();
            "
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-progress-circular
      indeterminate
      color="green"
      v-if="waitCircle"
      size="50"
      class="waitCircle"
    ></v-progress-circular>
  </v-app>
</template>

<script>
// import swimlanes from "./components/swimlanes";
import { components } from "aws-amplify-vue";
import { AmplifyEventBus } from "aws-amplify-vue";
import { Auth } from "aws-amplify";
import EventBus from "@/eventBus.js";
import utilityMixins from "@/utility-mixins.js";
import API, { graphqlOperation } from "@aws-amplify/api";
import * as subscriptions from "@/graphql/subscriptions";
import * as queries from "@/graphql/queries";
import { HTTP_GAP, HTTP_LND } from "@/http-common.js";
import recognizedRoles from "@/roles.js";

export default {
  mixins: [utilityMixins],
  name: "App",

  components: {
    // swimlanes
    ...components
  },
  beforeCreate() {
     AmplifyEventBus.$on("authState", () => {
    });

    // Handle Cognito OAuth redirect at root URL - Amplify exchanges the code here
    // then fires the signIn Hub event which we catch to complete login
    const { Hub } = require("aws-amplify");
     Hub.listen("auth", async ({ payload: { event } }) => {
      if (event === "signIn") {
        // Navigate to login to complete the login flow
        if (this.$router.currentRoute.path !== "/login") {
          this.$router.push({ path: "/login", query: { signedin: "true" } });
        }
      } else if (event === "signIn_failure" || event.indexOf("failure") >= 0) {
        if (this.$router.currentRoute.path !== "/login") {
          this.$router.push("/login");
        }
      }
    });
  },

  data: () => ({
    unlockMsg: "",
    unlockMsgFrom: "",
    unlockData: {},
    unlockAOName: "",
    overridePushed: false,
    overrideHier: "",
    overrideMsg: "",
    showDrawer: false,
    logOutDialog: false,
    activeCheckDialog: false,
    isAuthenticated: false,
    isJWTAuthenticated: false,
    updateSubscription: null,
    onRevokeSubscription: null,
    onUnlockSubscription: null,
    tokenTimeout: null,
    inactivityTimer: null,
    lastActiveTimeStamp: 0,
    tokenTimer: null,
    tokenTimeStamp: 0,
    userNameWatch: null,
    waitCircle: false
  }),

  mounted() {
    if (this.$route.query.accesscode) {
      this.userNameWatch = "";

      this.$store.commit("setCurrentUser", null);
      window.sessionStorage.removeItem("currentUser");

      EventBus.$emit("setUserName", null);

      this.$store.commit("setUserRoles", null);
      window.sessionStorage.removeItem("primaryAgentNum");

      this.$store.commit("setJWT", null);
      window.sessionStorage.removeItem("jwt");

      this.$store.commit("setAccessCode", null);
      window.sessionStorage.removeItem("accessCode");

      this.$store.commit("setTmkClientId", null);
      window.sessionStorage.removeItem("tmkClientId");

      EventBus.$emit("setIsJWTAuthenticated", false);
    }

    if (window.sessionStorage.getItem("jwt") != "invalid_jwt") {
      this.checkInactivity();
      this.refreshToken();

      if (
        window.sessionStorage.getItem("jwt") != null &&
        this.tokenTimeStamp == 0
      ) {
        this.refreshTokenOnReload();
      }
    }

    EventBus.$on(
      "overridePushed",
      function(hierAONum) {
        this.overridePushed = true;
        this.overrideHier = hierAONum;
      }.bind(this)
    );

    EventBus.$on(
      "logOutJWT",
      function() {
        clearInterval(this.tokenTimer);
      }.bind(this)
    );

    EventBus.$on(
      "logOutOK",
      function() {
        this.logOutDialog = true;
      }.bind(this)
    );

    EventBus.$on(
      "setIsJWTAuthenticated",
      function(val) {
        this.isJWTAuthenticated = val;
        window.sessionStorage.setItem("isJWTAuth", JSON.stringify(val));
        this.setupInactivityTimer();
        if (this.isJWTAuthenticated == true) this.setupTokenTimer();
      }.bind(this)
    );

    EventBus.$on(
      "setIsAuthenticated",
      function(val) {
        this.isAuthenticated = val;
        this.setupInactivityTimer();
        if (this.isAuthenticated) {
          this.subscribe();
          this.subscribeToUnlockedMsgs();
        }
      }.bind(this)
    );

    EventBus.$on(
      "setUserName",
      function(name) {
        this.userNameWatch = name;
      }.bind(this)
    );

    EventBus.$on(
      "showWaitCircle",
      function(val) {
        this.waitCircle = val;
      }.bind(this)
    );

    EventBus.$on(
      "setTmkClientId",
      function() {
        if (this.$store.state.currentDivision === 'GAP') {
          this.refreshTrueWriting();
        }
      }.bind(this)
    );

    this.isJWTAuthenticated =
      window.sessionStorage.getItem("jwt") != null &&
      window.sessionStorage.getItem("isJWTAuth") == "true"
        ? true
        : false;

    if (
      window.sessionStorage.getItem("accessCode") != null ||
      window.sessionStorage.getItem("jwt") != null ||
      this.isJWTAuthenticated == true
    ) {
      if (this.isJWTAuthenticated) {
          if (this.$store.state.currentDivision === 'GAP') {
            this.refreshTrueWriting();
          }
      }
    }
  },

  async beforeDestroy() {
    // this.logOutOnBeforeDestroy();

    // this.$store.commit("setUser", null);
    this.$store.commit("setCurrentUser", null);
    window.sessionStorage.removeItem("currentUser");

    EventBus.$emit("setUsername", null);
    this.$store.commit("setUserRoles", null);
    window.sessionStorage.removeItem("primaryAgentNum");
    this.isAuthenticated = false;

    document.removeEventListener("click", this.setLastActiveTimeStamp);
    window.removeEventListener("focus", this.onFocus);
    EventBus.$off("setIsAuthenticated");
    EventBus.$off("setIsJWTAuthenticated");
    EventBus.$off("logOutOK");
    EventBus.$off("showWaitCircle");
    EventBus.$off("logOutJWT");
    EventBus.$off("setTmkClientId");

    if (!window.sessionStorage.getItem("jwt")) this.unsubscribe();

    await Auth.signOut();
  },
  created() {
    if (this.$route.query.accesscode) {
      this.userNameWatch = "";
    }
    // window.addEventListener("beforeunload", function(e) {
    //   this.logOutOnBeforeDestroy();

    //   (e || window.event).returnValue = undefined;

    //   return undefined;
    // });

    this.$store.commit("setSession", this.PseudoGuid());
    window.addEventListener("focus", this.onFocus);
    document.addEventListener("click", this.setLastActiveTimeStamp);

    // this.$Amplify.Auth.currentAuthenticatedUser()
    //   .then((user) => {
    //     if (!user) {
    //       this.isAuthenticated = false;
    //     } else {
    //       this.isAuthenticated = true;
    //       this.setupInactivityTimer();
    //     }
    //   })
    //   .catch(() => {
    //     this.isAuthenticated = false;
    //   });

    if (window.sessionStorage.getItem("currentUser")) {
      let curUser = window.sessionStorage.getItem("currentUser");
      let user = JSON.parse(curUser);
      this.userNameWatch = user.name;
    }
  },
  methods: {
    homeClick() {
      const isIAMAdmin = this.$store.state.userRoles && this.$store.state.userRoles.includes(recognizedRoles.roles.IAMAdmin);
      if (isIAMAdmin) {
        return this.$route.path != "/division" ? this.$router.push("/division") : "";
      }
      if (
        this.$route.path == "/truewriting" ||
        this.$route.path == "/usermanagement" ||
        this.$route.path == "/user" ||
        this.$route.path == "/gap"
      ) {
        return this.$router.push("/gap");
      }
      if (
        this.$route.path.toLowerCase() == "/recruiting" ||
        this.$route.path.toLowerCase() == "/recruiting-user"
      ) {
        return this.$router.push("/recruiting");
      }
      return this.$route.path != "/" ? this.$router.push("/") : "";
    },
    refreshTrueWriting() {
      HTTP_GAP.get("ReadAgentTrueWriting", {
        params: {
          TMKClientID: window.sessionStorage.getItem("tmkClientId")
        }
      })
        .then(results => {
          if (results.status == 200) {
            this.$store.commit("setShowTrueWriting", results.data && results.data.length > 0);
          }
        })
        .catch(e => {
          this.addToErrorLogs("App.vue mounted ReadTrueWritingAgents", e);
        });
    },
    onCloseUnlockedMsgModal() {
      this.$modal.hide("unlockedMsgModal");
      EventBus.$emit("reloadHierarchy", this.unlockData.AOAgentNum);
    },

    routeHome() {
      if (
        this.$route.path.toLowerCase() == "/recruiting" ||
        this.$route.path.toLowerCase() == "/recruiting-user"
      ) {
        this.$router.push("/recruiting");
      } else if (
        this.$route.path.toLowerCase() == "/usermanagement" ||
        this.$route.path.toLowerCase() == "/user"
      ) {
        this.$router.push("/usermanagement");
      } else {
        this.$router.push("/");
      }
    },
    onFocus() {
      if (this.isAuthenticated == true || this.isJWTAuthenticated == true)
        this.checkInactivity();
    },
    unsubscribe() {
      try {
        if (this.updateSubscription) this.updateSubscription.unsubscribe();
        if (this.onRevokeSubscription) this.onRevokeSubscription.unsubscribe();
        if (this.onUnlockSubscription) this.onUnlockSubscription.unsubscribe();
      } catch (e) {
        this.addToErrorLogs("App.vue unsubscribe", e);
      }
    },

    subscribeToUnlockedMsgs() {
      try {
        this.onUnlockSubscription = API.graphql(
          graphqlOperation(subscriptions.onUnlock)
        ).subscribe({
          next: async eventData => {
            let ed = eventData.value.data.onUnlock;
            let AOAgentNum = ed.AOAgentNum;
            let Msg = ed.Msg;
            let Editing = ed.Editing;
            let From = ed.From;
            let To = ed.To;
            let FromName = ed.FromName;

            this.unlockData = ed;
            this.unlockMsg = Msg;
            this.unlockMsgFrom = FromName;

            if (Editing == true) {
              if (this.$store.state.currentUser.agentNum == To) {
                if (FromName == "OVERRIDE") {
                  EventBus.$emit(
                    "reloadHierarchyOnOverride",
                    AOAgentNum,
                    this.unlockMsg,
                    From,
                    this.unlockData
                  );
                } else {
                  EventBus.$emit("showMsgModal", this.unlockData);
                }
              }
            } else {
              if (
                this.$store.state.broadcastUnlock == true &&
                this.$store.state.unlockedHiers.find(uh => uh == AOAgentNum) !=
                  null
              ) {
                this.$store.commit("setBroadcastUnlock", false);
                this.$store.commit("setUnlockedHier", null);
              } else if (this.$route.path.toLowerCase() == "/office") {
                if (this.$store.state.currentAO.id == AOAgentNum) {
                  let results = await API.graphql(
                    graphqlOperation(queries.getUserByAgentNum, {
                      agentNum: AOAgentNum,
                      company: this.$store.state.currentCompany
                    })
                  ).catch(e => {
                    this.addToErrorLogs(
                      "App.vue subscribe getUserByAgentNum",
                      e
                    );
                    this.$modal.show("errorModal");
                    return false;
                  });

                  if (results && results.data.getUserByAgentNum.FirstName) {
                    this.unlockData.AOName =
                      (
                        results.data.getUserByAgentNum.FirstName +
                        " " +
                        results.data.getUserByAgentNum.MiddleName
                      ).trim() +
                      " " +
                      results.data.getUserByAgentNum.LastName;
                  }

                  this.unlockAOName = this.unlockData.AOName;

                  if (
                    this.overridePushed == true &&
                    this.overrideHier == ed.AOAgentNum
                  ) {
                    // If an override is in play,
                    // do not display the unlocked message
                    // to the person who overrode the lock
                    this.overridePushed = false;
                    this.overrideHier = "";
                  } else {
                    if (From == this.$store.state.currentUser.agentNum) {
                      EventBus.$emit(
                        "reloadHierarchyDueToSecondLogin",
                        AOAgentNum,
                        this.unlockAOName,
                        this.unlockData
                      );
                    } else {
                      if (
                        this.unlockData.ToSession == this.$store.state.session
                      ) {
                        this.$modal.show("unlockedMsgModal");
                      }
                    }
                  }
                }
              }
            }
          },
          error: () => {
            this.onUnlockSubscription.unsubscribe();
            this.subscribeToUnlockedMsgs();
          }
        });
      } catch (e) {
        this.addToErrorLogs("App.vue subscribeToUnlockedMsgs", e);
      }
    },
    subscribe() {
      try {
        this.onRevokeSubscription = API.graphql(
          graphqlOperation(subscriptions.onRevoke)
        ).subscribe({
          next: async eventData => {
            if (this.isAgencyUser) {
              let hier = eventData.value.data.onRevoke;
              if (
                this.$store.state.currentUser &&
                hier.AgentNum == this.$store.state.currentUser.agentNum
              ) {
                this.logOutAWS();
              }
            }
          }
        });

        this.updateSubscription = API.graphql(
          graphqlOperation(subscriptions.updatedHierarchy)
        ).subscribe({
          next: async eventData => {
            if (this.isAgencyUser) {
              for (let hier of eventData.value.data.updatedHierarchy.hiers) {
                if (
                  this.$store.state.currentUser &&
                  hier.agentNum == this.$store.state.currentUser.agentNum
                ) {
                  if (hier.GLHierarchyTypeRoleID) {
                    let roles;

                    roles = await API.graphql(
                      graphqlOperation(queries.getHierarchyRoles)
                    ).catch(e => {
                      this.addToErrorLogs(
                        "swimlanes-shell save getHierarchyRoles",
                        e
                      );
                      this.waitFlag = false;
                      return;
                    });

                    if (
                      roles.data.getHierarchyRoles &&
                      roles.data.getHierarchyRoles.length
                    ) {
                      let role = roles.data.getHierarchyRoles.find(
                        r => r.roleId == hier.GLHierarchyTypeRoleID
                      );

                      if (role) {
                        if (role.roleAbbr != "AO" && role.roleAbbr != "AA") {
                          this.logOutAWS();
                        }
                      }
                    }
                  }
                  break;
                }
              }
            }
          }
        });
      } catch (e) {
        this.addToErrorLogs("App.vue subscribe", e);
      }
    },

    setTokenTimeStamp() {
      this.tokenTimeStamp = new Date().getTime(); //epoch time
    },

    setupTokenTimer() {
      this.setTokenTimeStamp();
      this.tokenTimer = setInterval(this.checkToken, 2000); // 2 seconds
    },

    checkToken() {
      let jwt = window.sessionStorage.getItem("jwt");
      if (jwt == "invalid_jwt") return;

      const force_to_refresh = 25 * 60 * 1000; // 25 minutes

      if (this.tokenTimeStamp == 0) {
        this.setupTokenTimer();
        return;
      }

      let now = new Date().getTime();
      let diff = now - this.tokenTimeStamp;
      if (diff > force_to_refresh) {
        clearInterval(this.tokenTimer);

        if (
          window.sessionStorage.getItem("accessCode") != null &&
          window.sessionStorage.getItem("accessCode").endsWith("-TE5E")
        ) {
          HTTP_LND.post("/exchangejwt", {
            jwt: window.sessionStorage.getItem("jwt")
          })
            .then(results => {
              if (results.status == 200) {
                window.sessionStorage.setItem("jwt", results.data.jwt);
                this.$store.commit("setJWT", results.data.jwt);

                this.setupTokenTimer();
              }
            })
            .catch(err => {
              this.addToErrorLogs("App.vue checkToken exchangejwt", err);
            });
        } else {
          HTTP_GAP.post("/exchangejwt", {
            jwt: window.sessionStorage.getItem("jwt")
          })
            .then(results => {
              if (results.status == 200) {
                window.sessionStorage.setItem("jwt", results.data.jwt);
                this.$store.commit("setJWT", results.data.jwt);

                this.setupTokenTimer();
              }
            })
            .catch(err => {
              this.addToErrorLogs("App.vue checkToken exchangejwt", err);
            });
        }
      }
    },
    refreshTokenOnReload() {
      let jwt = window.sessionStorage.getItem("jwt");
      if (jwt == "invalid_jwt") return;

      if (
        window.sessionStorage.getItem("accessCode") != null &&
        window.sessionStorage.getItem("accessCode").endsWith("-TE5E")
      ) {
        HTTP_LND.post("/exchangejwt", {
          jwt: window.sessionStorage.getItem("jwt")
        })
          .then(results => {
            if (results.status == 200) {
              window.sessionStorage.setItem("jwt", results.data.jwt);
              this.$store.commit("setJWT", results.data.jwt);
              this.setupTokenTimer();
            }
          })
          .catch(err => {
            this.addToErrorLogs(
              "App.vue refreshTokenOnReload exchangejwt",
              err
            );
          });
      } else {
        HTTP_GAP.post("/exchangejwt", {
          jwt: window.sessionStorage.getItem("jwt")
        })
          .then(results => {
            if (results.status == 200) {
              window.sessionStorage.setItem("jwt", results.data.jwt);
              this.$store.commit("setJWT", results.data.jwt);

              this.setupTokenTimer();
            }
          })
          .catch(err => {
            this.addToErrorLogs(
              "App.vue refreshTokenOnReload exchangejwt",
              err
            );
          });
      }
    },
    refreshToken() {
      clearTimeout(this.tokenTimeout);

      if (window.sessionStorage.getItem("jwt") == null) {
        this.tokenTimeout = setTimeout(() => {
          Auth.currentSession()
            .then(() => {
              this.refreshToken();
            })
            .catch(err => this.addToErrorLogs("App.vue refreshToken", err));
        }, 30 * 60 * 1000); // refresh the token every thirty minutes
      }
    },
    setLastActiveTimeStamp() {
      if (this.activeCheckDialog == false || !this.activeCheckDialog) {
        this.lastActiveTimeStamp = new Date().getTime(); //epoch time
        this.hideActiveCheckDialog();
      }
    },
    setupInactivityTimer() {
      //Only start timer when isAuthenticated
      if (this.isAuthenticated == true || this.isJWTAuthenticated == true) {
        this.setLastActiveTimeStamp();
        this.inactivityTimer = setInterval(this.checkInactivity, 2000); // 2 seconds
      } else {
        //remove timer
        this.lastActiveTimeStamp = 0;
        clearInterval(this.inactivityTimer);
      }
    },
    hideActiveCheckDialog() {
      if (this.activeCheckDialog) {
        this.$refs.activeCheckDialog.removeOverlay();
        let elements = document.getElementsByClassName("v-overlay--active");
        for (let el of elements) {
          el.style.display = "none";
        }
        this.activeCheckDialog = false;
      }
    },
    checkInactivity() {
      const force_to_log_out = 60 * 60 * 1000; // 60 minutes
      const show_active_check_dialog = 55 * 60 * 1000; // 55 minutes

      //lastActiveTimeStamp == 0, meaning new session, setup timer
      if (this.lastActiveTimeStamp == 0) {
        this.setupInactivityTimer();
        return;
      }
      let now = new Date().getTime();
      let diff = now - this.lastActiveTimeStamp;
      if (diff > force_to_log_out) {
        this.hideActiveCheckDialog();
        this.activeCheckDialog = false;
        clearInterval(this.inactivityTimer);
        this.$nextTick(function() {
          this.logOutAWS();
        });
        return;
      }
      if (diff > show_active_check_dialog) {
        this.activeCheckDialog = true;
      }
    },

    refresh() {
      clearTimeout(this.timeout);
      clearTimeout(this.secondaryTimeout);

      this.timeout = setTimeout(() => {
        if (this.isAuthenticated == true || this.isJWTAuthenticated == true) {
          this.activeCheckDialog = true;
          this.secondaryTimeout = setTimeout(() => {
            if (this.activeCheckDialog) {
              this.$refs.activeCheckDialog.removeOverlay();

              let elements = document.getElementsByClassName(
                "v-overlay--active"
              );

              for (let el of elements) {
                el.style.display = "none";
              }

              this.activeCheckDialog = false;

              this.$nextTick(function() {
                this.logOutAWS();
              });
            }
          }, 5 * 60 * 1000); // 5 minutes
        }
      }, 55 * 60 * 1000); // 55 minutes
    },

    logOut() {
      if (this.$route.path == "/office") EventBus.$emit("logOutRequest");
      else this.logOutDialog = true;
    },

    logOutAWS() {
      this.$router.push("/logout");
    }
  },

  computed: {
    userName() {
      return this.userNameWatch;
    },
    showLogOut() {
      return this.isAuthenticated == true || this.isJWTAuthenticated == true;
    },
    links() {
      const isIAMAdmin = this.$store.state.userRoles && this.$store.state.userRoles.includes(recognizedRoles.roles.IAMAdmin);
      //const hasFHDRole = this.$store.state.userRoles && this.$store.state.userRoles.split(",").some(r => r.includes("FHD"));
      const fhdSelected = this.$store.state.fhdSelected;
      const suppressFHD = isIAMAdmin && !fhdSelected;

      let linkArray = [
        {
          name: "Division Selection",
          route: "/division",
          icon: "mdi-view-list",
          requiredRole: recognizedRoles.roles.IAMAdmin
        },
        ...(isIAMAdmin && this.$store.state.currentDivision === "GAP" ? [{
          name: "GAP Agent Selection",
          route: "/gap-selection",
          icon: "mdi-account-search"
        }] : []),
        ...(isIAMAdmin && this.$store.state.currentDivision === "LND" ? [{
          name: "LND Agent Selection",
          route: "/lnd-selection",
          icon: "mdi-account-search"
        }] : []),
        { name: "Home", route: "/", icon: "mdi-home", fhdOnly: true },
        {
          name: "Lead Management Hierarchy",
          route: "/hierarchy",
          icon: "mdi-account-supervisor",
          fhdOnly: true
        },
        {
          name: "Manage Agency Owners",
          route: "/replace",
          icon: "mdi-account-convert",
          fhdOnly: true
        },
        {
          name: "Agency Office Name & Address Editor",
          route: "/agency",
          icon: "mdi-lead-pencil",
          fhdOnly: true
        },
        {
          name: "Agency Office Updates History",
          route: "/history",
          icon: "mdi-history",
          fhdOnly: true
        }
      ];

      if (suppressFHD) {
        linkArray = linkArray.filter(l => !l.fhdOnly);
      }

      if (isIAMAdmin) {
        const path = this.$route.path.toLowerCase();
        const gapPaths = ["/gap", "/usermanagement", "/user", "/truewriting"];
        const recruitingPaths = ["/recruiting", "/recruiting-user"];

        if (gapPaths.includes(path)) {
          linkArray.push({ name: "Manage Office Admin Users", route: "/usermanagement", icon: "mdi-account" });
          if (this.$store.state.showTrueWriting) {
            linkArray.push({ name: "Manage True Writing Agents", route: "/truewriting", icon: "mdi-account" });
          }
        } else if (recruitingPaths.includes(path)) {
          linkArray.push({ name: "Recruiting Home", route: "/recruiting", icon: "mdi-home" });
        }
      }

      if (this.isAgencyUser) {
        linkArray = [{ name: "Home", route: "/hierarchy", icon: "mdi-home" }];
      }

      if (
        !isIAMAdmin &&
        (
          window.sessionStorage.getItem("accessCode") != null ||
          window.sessionStorage.getItem("jwt") != null ||
          this.isJWTAuthenticated == true
        )
      ) {
        if (
          window.sessionStorage.getItem("jwt") != null &&
          window.sessionStorage.getItem("jwt") != "invalid_jwt"
        ) {
          if (
            window.sessionStorage.getItem("accessCode") != null &&
            window.sessionStorage.getItem("accessCode").endsWith("-TE5E")
          ) {
            // LND Recruiting
            linkArray = [
              {
                name: "Home",
                route: "/recruiting",
                icon: "mdi-home"
              }
            ];
          } else {
            // GAP
            linkArray = [
              {
                name: "View Office Admin Users",
                route: "/usermanagement",
                icon: "mdi-home"
              }
            ];
          }
        } else {
          linkArray = [
            { name: "Home", route: "/unauthenticated", icon: "mdi-home" }
          ];
        }
      }
      if (!isIAMAdmin && this.$store.state.showTrueWriting) {
        linkArray = [
          {
            name: "View Admin Office Users",
            route: "/usermanagement",
            icon: "mdi-home"
          },
          {
            name: "View True Writing Agents",
            route: "/truewriting",
            icon: "mdi-home"
          }
        ];
      }

      let ret = [];

      if (!this.isAuthenticated) {
        // User can't be found, only show links which don't require permissions

        for (let link of linkArray) {
          if (link.route.toLowerCase() != this.$route.path.toLowerCase()) {
            if (link.requiredRole) {
              if (this.$store.state.userRoles && this.$store.state.userRoles.includes(link.requiredRole)) {
                ret.push(link);
              }
            } else {
              for (let route of this.$router.options.routes) {
                if (route.path.toLowerCase() == link.route.toLowerCase()) {
                  let authorize = null;

                  if (route.meta != null) {
                    authorize = route.meta.authorize;
                  }

                  if (authorize == null || authorize.length == 0) {
                    ret.push(link);
                  }
                }
              }
            }
          }
        }

        return ret;
      } else {
        for (let link of linkArray) {
          if (link.route.toLowerCase() != this.$route.path.toLowerCase()) {
            if (link.requiredRole) {
              if (this.$store.state.userRoles && this.$store.state.userRoles.includes(link.requiredRole)) {
                ret.push(link);
              }
            } else {
              for (let route of this.$router.options.routes) {
                if (route.path.toLowerCase() == link.route.toLowerCase()) {
                  let authorize = null;

                  if (route.meta != null) {
                    authorize = route.meta.authorize;
                  }

                  if (authorize == null || authorize.length == 0) {
                    ret.push(link);
                  } else {
                    let roles = this.$store.state.userRoles.split(",");

                    let authorized = false;

                    for (let role of roles) {
                      if (role && authorize.includes(role)) {
                        authorized = true;
                      }
                    }

                    if (authorized) {
                      ret.push(link);
                    }
                  }
                }
              }
            }
          }
        }

        return ret;
      }
    }
  }
};
</script>
<style scoped>
.waitCircle {
  z-index: 50;
  position: absolute;
  top: 25%;
  left: 47%;
}
.unlockMsgRcvd {
  font-weight: bold;
  font-style: italic;
}
</style>
